export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4596.37408fcb.jpg";